// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__igol4","imageSmall":"footer_imageSmall__nbEVZ","cltopLine":"footer_cltopLine__kHi5X"};